var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer px-4"},[_c('b-row',{staticClass:"justify-content-lg-between",attrs:{"align-v":"center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }